module.exports = __webpack_public_path__ + "static/media/file-pdf.94e084ab.svg";